import React, { useState, useEffect } from "react";
import api from "../api/homeapi";
import { StaffFrame } from "./DashboardShared";

const C = { green:"#006B3C", greenLt:"#E8F5EE", grayBd:"#E0E0E0", text:"#1A1A1A", textSub:"#666" };

export default function AdminUsers() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState("");

  useEffect(() => {
    api.get("/api/admin/users").then(r => setUsers(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = search
    ? users.filter(u => u.name?.toLowerCase().includes(search.toLowerCase()) || u.email?.toLowerCase().includes(search.toLowerCase()))
    : users;

  const ROLE_STYLE = {
    ROLE_ADMIN:  { bg:"#FEE2E2", color:"#991B1B", label:"Admin" },
    ROLE_CLIENT: { bg:C.greenLt, color:C.green,   label:"Voyageur" },
  };

  return (
    <StaffFrame>
      <div style={{ padding:28 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
          <div>
            <h1 style={{ margin:0, fontSize:22, fontWeight:800 }}>Voyageurs</h1>
            <p style={{ margin:0, color:C.textSub, fontSize:13 }}>{users.length} comptes enregistrés</p>
          </div>
          <input
            placeholder="Rechercher un voyageur..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ border:`1.5px solid ${C.grayBd}`, borderRadius:10, padding:"9px 14px", fontSize:13, outline:"none", width:240 }}
          />
        </div>

        {loading ? (
          <div style={{ textAlign:"center", padding:60, color:C.textSub }}>Chargement...</div>
        ) : (
          <div style={{ background:"#fff", borderRadius:14, overflow:"hidden", border:`1px solid ${C.grayBd}` }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ background:C.greenLt }}>
                  {["ID","Nom","Email","Téléphone","Rôle","Actions"].map(h => (
                    <th key={h} style={{ padding:"11px 14px", textAlign:"left", fontSize:11, fontWeight:700, color:C.textSub, textTransform:"uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((u,i) => {
                  const role = u.roles?.find(r => r !== "ROLE_USER") || "ROLE_CLIENT";
                  const rs = ROLE_STYLE[role] || ROLE_STYLE.ROLE_CLIENT;
                  return (
                    <tr key={u.id} style={{ borderTop:`1px solid ${C.grayBd}`, background:i%2===0?"#fff":"#FAFAFA" }}>
                      <td style={s.td}>{u.id}</td>
                      <td style={s.td}><strong>{u.name}</strong></td>
                      <td style={s.td}>{u.email}</td>
                      <td style={s.td}>{u.phone}</td>
                      <td style={s.td}>
                        <span style={{ background:rs.bg, color:rs.color, padding:"3px 9px", borderRadius:20, fontSize:11, fontWeight:600 }}>
                          {rs.label}
                        </span>
                      </td>
                      <td style={s.td}>
                        <button style={{ background:"#F5F5F5", border:"none", borderRadius:6, padding:"4px 12px", fontSize:12, cursor:"pointer" }}>
                          Voir
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {filtered.length === 0 && (
              <div style={{ textAlign:"center", padding:40, color:C.textSub }}>Aucun voyageur trouvé.</div>
            )}
          </div>
        )}
      </div>
    </StaffFrame>
  );
}

const s = { td: { padding:"11px 14px", fontSize:13 } };
